// zh-Hans — Simplified Chinese.
// Keys mirror zh-Hant.js. Strings translated to Simplified Chinese
// using Hong Kong/Mainland conventions (e.g. 載入 → 加载, 設定 → 设置).

export default {
  'app.title':           'Finance',
  'app.loading':         '加载中...',
  'nav.dashboard':       '仪表板',
  'nav.transactions':    '交易',
  'nav.budgets':         '预算',
  'nav.settings':        '设置',
  'bottomnav.aria':      '主要导航',
  'sidebar.aria':        '桌面导航',

  'topbar.theme':        '切换主题',

  'dashboard.title':     '仪表板',
  'dashboard.income':    '收入',
  'dashboard.expense':   '支出',
  'dashboard.net':       '净值',
  'dashboard.networth': '净资产',
  'dashboard.networthHelper': '总收入 − 总支出（全部时间）',
  'dashboard.networthPositive': '在储蓄',
  'dashboard.networthNegative': '赤字中',
  'dashboard.savings':   '储蓄率',
  'dashboard.balance':   '结余',
  'dashboard.vsLast':    '对比上月',
  'kpi.noComparison': '无上期数据',
  'dashboard.rangeLabel': '时段',
  'dashboard.rangeHint': '点一下跳到当期 · 长按 / 右键切换日/月/年/5年',
  'dashboard.vsYesterday':'昨日',
  'dashboard.vsLastYear':'对比去年',
  'dashboard.range.day': '日',
  'dashboard.range.month':'月',
  'dashboard.range.year':'年',
  'dashboard.range.5y': '5年',
  'dashboard.prevPeriod':'上一期',
  'dashboard.nextPeriod':'下一期',
  'dashboard.allCats':   '全部',
  'dashboard.autoApplied':'自动记录了 {n} 笔固定交易',
  'dashboard.forecast.title': '未来 30 日现金流预测',
  'dashboard.forecast.subtitle': '根据你的固定交易规则,预测下个月的余额走势',
  'dashboard.forecast.todayBalance': '今日余额',
  'dashboard.forecast.projection30d': '+30 日预计',
  'dashboard.forecast.delta': '对比今日',
  'dashboard.forecast.activeCount': '{n} 条生效中',
  'dashboard.forecast.income': '收入',
  'dashboard.forecast.expense': '支出',
  'dashboard.forecast.legend.balance': '预计余额',
  'dashboard.forecast.legend.events': '收入 / 支出事件',
  'dashboard.forecast.empty.title': '暂时未有预测',
  'dashboard.forecast.empty.body': '设定固定交易之后,就可以看到下个月的现金流预测。',
  'dashboard.forecast.empty.cta': '去设定固定交易 →',
  'dashboard.forecast.tooltip.balance': '余额',
  'dashboard.forecast.tooltip.events': '{n} 个事件',

  'tx.title':            '交易',
  'transactions.openFilters': '筛选',
  'transactions.filters': '筛选',
  'transactions.filterDrawerTitle': '筛选交易',
  'transactions.typeLabel': '类型',
  'transactions.categoryLabel': '类别',
  'transactions.searchLabel': '搜索',
  'transactions.removeFilter': '移除筛选：{name}',
  'transactions.resetFilters': '重置',
  'transactions.applyFilters': '应用',
  'transactions.cardsTitle': '信用卡',
  'transactions.cardFilterActive': '已启用筛选',
  'transactions.filterByCard': '只看{name}的交易',
  'transactions.unfilterCard': '显示全部卡（清除筛选）',
  'transactions.noCardMatch': '这段时间没有这张卡的交易',
  'tx.search':           '搜索备注或类别',
  'tx.empty':            '暂无交易',
  'tx.emptyHint': '点击下方按钮添加第一笔',
  'tx.thisMonth':        '本月',
  'tx.lastMonth':        '上月',
  'tx.last30':           '近30日',
  'tx.ytd':              '本年',
  'tx.all':              '全部',
  'tx.expense':          '支出',
  'tx.income':           '收入',
  'tx.allPeriod':        '全期',
  'tx.allCats':          '全部类别',
  'tx.tagLabel':         '标签:',
  'tx.edit':             '编辑',
  'tx.delete':           '删除',
  'tx.deleteConfirm':    '确定删除这笔交易?',
  'tx.bulkSelected':     '已选 {n} 笔',
  'tx.bulkCancel':       '取消',
  'tx.bulkSelectAll':    '全选',
  'tx.bulkClear':        '清除选取',
  'tx.bulkDeleteConfirm':'确定删除已选的 {n} 笔交易?',
  'tx.bulkDeleted':      '已删除 {n} 笔交易',
  // Phase 111: recurring badge
  'tx.recurring':        '固定',

  'add.newTitle':        '新增交易',
  'add.editTitle':       '编辑交易',
  'add.expense':         '支出',
  'add.income':          '收入',
  'add.amount':          '金额',
  'add.category':        '类别',
  'add.date':            '日期',
  'add.note':            '备注',
  'add.notePlaceholder': '可选',
  // Phase 80: mode-toggle buttons inside the add modal.
  'add.modeAdd':         '新增',
  'add.modeTransfer':    '转账',
  // Phase 80: single merged payment-method picker.
  'add.paymentMethod':   '支付方式',
  'add.tags':            '标签',
  'add.tagsPlaceholder': '用逗号分隔',
  'add.card':            '信用卡',
  'add.cardNone':        '不适用',
  'add.today':           '今天',
  // Phase 203: quick date chips in the Add Transaction form.
  'add.yesterday':       '昨天',
  'add.dayBefore':       '前天',
  // Phase 186 (M-113): 高级选项折叠面板(收起 tag/note/bulk)。
  'add.advanced':        '高级选项',
  // Phase 189 (M-116): pager 控制(上一页/下一页箭头 + 圆点指示)。
  'addCategoryPager.prev': '上一页',
  'addCategoryPager.next': '下一页',
  'addCategoryPager.pageIndicator': '第 {n}/{total} 页',
  // Phase 189 (M-116): AddCategoryModal 抽屉 labels。
  'addCategory.title':          '新增类别',
  'addCategory.newCategory':    '＋ 新增类别',
  'addCategory.nameLabel':      '名称',
  'addCategory.namePlaceholder':'例如：咖啡基金',
  'addCategory.iconLabel':      '图标',
  'addCategory.colorLabel':     '颜色',
  // Phase 49: bulk apply to date range
  'bulk.applyToRange':   '应用到日期范围',
  'bulk.endDate':        '结束日期',
  'bulk.dayOfWeek':      '星期',
  'bulk.weekdayShort':   ['日', '一', '二', '三', '四', '五', '六'],
  'bulk.presetWeekdays': '工作日 (一至五)',
  'bulk.presetEveryDay': '每天',
  'bulk.presetMWF':      '一/三/五',
  'bulk.preview':        '将新增 {count} 笔交易',
  'bulk.emptyRange':     '范围内无符合的日期',
  'add.cancel':          '取消',
  'add.save':            '保存',
  'add.saved':           '保存成功',
  'add.failed':          '保存失败: {msg}',

  'budgets.title':       '预算',
  'budgets.empty':       '未设置预算',
  'budgets.emptyHint':   '在每个类别点击「设置上限」即可保存',
  'budgets.setLimit':    '设置上限',
  'budgets.used':        '已用',
  'budgets.of':          '/',
  'budgets.overBudget':  '超出预算!',
  'budgets.heroTotal':   '本月总预算',
  'budgets.heroRemaining': '剩余 {amount}',
  'budgets.heroOverBy':  '超出 {amount}',
  'budgets.heroNoBudgets': '本月尚未设置预算',
  'budgets.heroNoBudgetsHint': '在类别设置上限即可开始追踪',
  'budgets.heroPctAria': '本月总预算已用 {pct}',

  // ─── Savings Goals (Phase 48) ────────────────────────────────────────
  'goals.title':                  '储蓄目标',
  'goals.widgetTitle':            '储蓄目标 ({n})',
  'goals.widgetEmpty':            '设定目标看到自己的进度',
  'goals.summary':                '目标总览',
  'goals.summaryPctAria':         '总体进度 {pct}',
  'goals.empty':                  '未设定储蓄目标',
  'goals.emptyHint':              '设定一个目标开始追踪储蓄进度',
  'goals.addGoal':                '新增目标',
  'goals.editGoal':               '编辑目标',
  'goals.deleteGoal':             '删除目标',
  'goals.deleteConfirm':          '删除目标「{name}」?',
  'goals.field.name':             '目标名称',
  'goals.field.target':           '目标金额',
  'goals.field.current':          '目前已存',
  'goals.field.deadline':         '目标日期',
  'goals.field.trackingFrom':     '起始日期',
  'goals.field.icon':             '图标',
  'goals.field.color':            '颜色',
  'goals.field.allocationPct':    '每月分配 (%)',
  'goals.field.active':           '启用',
  'goals.paused':                 '暂停',
  'goals.activeOn':               '启用中',
  'goals.activeOff':              '已暂停',
  'goals.pctSumUnder':           '现时合计 {sum}% (< 100 OK, 剩余不追踪)',
  'goals.pctSumOver':            '现时合计 {sum}% (> 100 不能保存)',
  'goals.allocationHint':         '每月 {pct}% 储蓄 · 预计 {months} 个月',
  'goals.mode.auto':              '自动',
  'goals.mode.manual':            '手动',
  'goals.eta':                    '预计 {days} 日达标',
  'goals.etaMonths':              '预计 {months} 个月达标',
  'goals.etaDate':                '预计 {date} 达标',
  'goals.etaNoHistory':           '—',
  'goals.completed':              '已达标',
  'goals.completedOver':          '已超标 +{amount}',
  'goals.progressAria':           '{name} 已存 {pct}',
  'goals.overrides':              '预填金额',
  'goals.section':                '储蓄目标 ({count})',  'accounts.title': '账户及钱包',
  'transfer.title': '转账',
  'accounts.widgetTotal': '所有账户合计',
  'accounts.widgetEmpty': '尚未新增账户',
  'chart.viewAsChart': '查看图表',
  'chart.close': '关闭图表',
  'transfer.mode': '转账模式',
  'transfer.from': '从账户',
  'transfer.to': '到账户',
  'transfer.sameAccount': '来源与目标账户必须不同',
  'transfer.success': '转账已记录',
  'transfer.filter': '只显示转账',
  'transfer.tag': 'transfer',
  // Phase 203: specific transfer validation errors. Before, every
  // failure showed 'transfer.sameAccount' — so "pick a destination
  // account" was reported as "source and destination must differ".
  'transfer.errMissingFrom':     '请选择转出账户',
  'transfer.errMissingTo':       '请选择转入账户',
  'transfer.errInvalidAmount':   '请输入大于零的金额',
  'transfer.errAccountMissing':  '该账户已不存在',
  'transfer.noAccountsHint':     '请先在设置新增账户，才可记录转账',
  'accounts.label': '账户',
  'accounts.add': '新增账户',
  'accounts.all': '全部账户',
  'accounts.defaultName': '现金',


  'settings.title':      '设置',
  'settings.subnavLabel': '设置分区',
  'settings.subnavCurrency': '货币',
  'settings.subnavCards': '信用卡',
  'settings.subnavRecurring': '周期',
  'settings.subnavCategories': '类别',
  'settings.subnavGoals': '目标',
  'settings.subnavData': '资料',
  'settings.subnavAbout': '关于',
  'settings.section.cash':           '现金',
  'settings.section.cards':          '信用卡 ({n})',
  'settings.section.recurring':      '固定每月收入/支出 ({n})',
  'settings.section.expenseCats':    '支出类别 ({n})',
  'settings.section.incomeCats':     '收入类别 ({n})',
  'settings.section.sync':           'Google 同步',
  'settings.section.data':           '数据',
  'settings.section.currency':       '货币',
  'settings.section.appearance':     '外观',
  'settings.section.about':          '关于',
  'settings.section.language':       '语言',

  'settings.language.label':     '界面语言',
  'settings.language.help':      '切换后即时生效',

  'settings.appearance.dark':    '深色模式',
  'settings.appearance.compact': '紧凑布局',

  'settings.about.storage':      '数据存储: 本机 SQLite ({path})',
  'settings.about.localOnly':    '所有数据保留在你设备上,不上云。',
  'settings.about.title':        '关于',
  'settings.cardName':           '卡名',
  'settings.cardNamePlaceholder': '例: 汇丰白金卡',
  'settings.dueDay':             '到期日',
  'settings.outstandingAmount':  '未付金额',
  'settings.symbolExists':       '这个符号已经存在',
  'settings.addSymbolFailed':    '添加失败：{msg}',
  'settings.removeSymbolConfirm':'删除符号「{symbol}」？',
  'settings.keepOneSymbol':      '至少保留一个符号',
  'settings.removeSymbolFailed': '删除失败：{msg}',

  'settings.recurring.add':      '添加',
  'settings.recurring.edit':     '编辑',
  'settings.recurring.delete':   '删除',
  'settings.recurring.monthly':  '每月 {n} 日',
  'settings.recurring.addTitle': '新增固定规则',
  'settings.recurring.editTitle':'编辑固定规则',
  'settings.recurring.type':     '类型',
  'settings.recurring.category': '类别',
  'settings.recurring.amount':   '金额',
  'settings.recurring.day':      '每月几号',
  'settings.recurring.dayPlaceholder': '例: 1 (每月 1 号)',
  'settings.recurring.note':     '备注',
  'settings.recurring.notePlaceholder': '例: 月薪',
  'settings.recurring.from':     '起始月份',
  'settings.recurring.to':       '结束月份（选填）',
  'settings.recurring.autoApplied': '📌 已自动记录了 {n} 笔固定交易:\n{lines}',
  'settings.recurring.cancel':   '取消',
  'settings.recurring.save':     '保存',
  'settings.recurring.deleteConfirm': '删除此固定规则?',
  'settings.recurring.amountPlaceholder': '例: 30000',
  'settings.recurring.fromPlaceholder': '开始月份',
  'settings.recurring.toPlaceholder': '不限',
  'settings.recurring.period':   '{from} → {to}',

  'settings.category.name':      '名称',
  'settings.category.type':      '类型',
  'settings.category.icon':      '图标',
  'settings.category.color':     '颜色',
  'settings.category.addNew':    '新增类别',
  'settings.category.editOne':   '编辑类别',
  'settings.category.cancel':    '取消',
  'settings.category.save':      '保存',
  'settings.category.nameRequired':'请输入名称',
  'settings.category.deleteConfirm':'删除类别「{name}」?',
  'settings.category.namePlaceholder': '例: 订阅',
  'settings.category.expense': '支出',
  'settings.category.income': '收入',
  'settings.category.colorAria': '颜色 {color}',
  // Phase 79f: defaults have a small badge + enable/disable toggle.
  'settings.category.defaultBadge': '默认',
  'settings.category.defaultHint':  '默认类别不可编辑或删除 — 只能启用/停用',
  'settings.category.enable':       '启用',
  'settings.category.disable':      '停用',

  'common.back':         '返回',
  'common.cancel':       '取消',
  'common.save':         '保存',
  'common.search':       '搜索',
  'common.delete':       '删除',
  'common.confirmDelete':'确认删除?',
  'common.edit':         '编辑',
  'common.confirm':      '确认',
  'common.close':        '关闭',
  'common.failed':       '保存失败: {msg}',
  'common.failedDelete': '删除失败: {msg}',
  'common.deleteConfirm':'确定删除?',
  'common.today':        '今天',
  'common.unknown':      '未命名',
  'common.optional':     '可选',
  'common.none':         '不限',

  'err.generic':         '出错了: {msg}',

  'signin.title':        '连接 Google 账户',
  'signin.subtitle':     '数据将在你的设备和 Google Drive 之间同步',
  'signin.button':       '使用 Google 登录',
  'signin.skip':         '稍后再说 (本地使用)',
  'signin.connected':    '已连接',
  'signin.disconnect':   '登出',

  'cmd.placeholder':     '搜索指令、页面或交易...',
  'cmd.section.pages':   '页面',
  'cmd.section.actions': '指令',
  'cmd.section.recent':  '近期交易',
  'cmd.theme.toggle':    '切换主题',
  'cmd.theme.dark':      '深色模式',
  'cmd.theme.light':     '浅色模式',
  'cmd.lang.switch':     '切换语言',
  'cmd.shortcutHint':    '按 ⌘K / Ctrl K 打开搜索',

  'placeholder.noData':  '暂无数据',
  'placeholder.addFirst':'添加第一笔',

  'dashboard.refresh.refreshing': '⟳ 更新中…',
  'dashboard.refresh.release': '↓ 鬆開更新',
  'dashboard.kpi.incomeYear': '收入(年)',
  'dashboard.kpi.incomeDay': '收入(今日)',
  'dashboard.kpi.income5y': '收入(5年)',
  'dashboard.kpi.expenseYear': '支出(年)',
  'dashboard.kpi.expenseDay': '支出(今日)',
  'dashboard.kpi.expense5y': '支出(5年)',
  'dashboard.kpi.netYear': '净值(年)',
  'dashboard.kpi.netDay': '净值(今日)',
  'dashboard.kpi.net5y': '净值(5年)',
  'dashboard.rangeLabel.year': '全年 12 个月',
  'dashboard.rangeLabel.week': '过去 7 日',
  'dashboard.rangeLabel.halfYear': '过去 6 个月',
  'dashboard.rangeLabel.fiveYear': '过去 5 年（60 个月）',
  'dashboard.filter.title': '筛选',
  'dashboard.filter.openFilters': '筛选',
  'dashboard.filter.typeLabel': '类型',
  'dashboard.filter.categoriesLabel': '类别',
  'dashboard.filter.amountLabel': '金额范围',
  'dashboard.filter.amountMin': '最小',
  'dashboard.filter.amountMax': '最大',
  'dashboard.trend.yoyLabel': '对比 {ym}',
  'dashboard.trend.yoyIncome': '收入(去年)',
  'dashboard.trend.yoyExpense': '支出(去年)',
  'dashboard.trend.viewLabel': '走势图视图',
  'dashboard.trend.viewTimeline': '时间轴',
  'dashboard.trend.viewByYear': '按年比较',
  'dashboard.trend.metricLabel': '指标',
  'dashboard.onlyShowing': '只显示 {name}',
  'dashboard.autoAppliedFmt': '📌 自动记录了 {n} 笔固定交易',
  'dashboard.card.dueTodayTitle': '💳 {name} 今日到期',
  'dashboard.card.dueInDaysTitle': '💳 {name} {n} 日后到期',
  'dashboard.card.unpaidHint': '{amount} 未还 · 记得交卡数',
  'dashboard.card.graceSuffix': '（剩 {n} 日免息期）',
  'filter.all': '全部',
  'filter.thisMonth': '本月',
  'filter.lastMonth': '上月',
  'filter.thisYear': '本年',
  'filter.date': '日期',
  'filter.amount': '金额',
  'filter.sortByDate': '依日期排序',
  'filter.sortByAmount': '依金额排序',
  'filter.noMatches': '这段时间没有交易',
  'dashboard.card.overdue': '已逾期 {n} 日 · {date}',
  'dashboard.card.paidOn': '已于 {date} 缴付',
  'dashboard.card.allPaid': '所有卡本周期已缴清',
  'dashboard.card.dueToday': '今日到期 · {date}',
  'dashboard.card.dueTomorrow': '明日到期 · {date}',
  'dashboard.card.dueInDaysFmt': '{n} 日后到期 · {date}',
  'placeholder.empty': '暂无数据',
  'common.loadingDots': '加载中…',
  'dashboard.filtering': '只显示 ',
  'common.clear': '清除',
  'dashboard.netWorthSummary': '收入 {income} · 支出 {expense}',
  'dashboard.categoryBreakdown': '类别分布',
  'common.manage': '管理',
  'dashboard.cardReminder': '提醒交卡数',
  'dashboard.recentTransactions': '最近交易',
  'budgets.alerts': '预算警示',
  'tx.seeAll': '查看全部',
  'tx.prevMonth': '上个月',
  'tx.nextMonth': '下个月',
  'common.clearSearch': '清除搜索',
  'tx.noSearchMatch': '没有符合「{q}」的交易',
  'add.dirtyConfirm': '放弃这笔未保存的资料?',
  // Phase 106 (M-36): first-transaction celebration banner.
  'add.firstTxCelebration': '🎉 第一笔记录!记账正式开始',
  'common.saving': '保存中…',
  'add.noCardsHint': '尚未添加信用卡。去「设置」添加一张。',
  'budgets.deleteConfirm': '清除此类别预算上限?',
  'budgets.clear': '清除',
  'budgets.description': '设置每月各类别上限,超支时 Dashboard 会提示。',
  'budgets.thisMonthUsage': '本月 {spent} / {limit}',
  'budgets.limitPlaceholder': '每月上限',
  'budgets.invalidAmount': '预算必须是正数',
  'settings.cardsTitle': '信用卡 ({count})',
  'settings.cardsEmpty': '尚未添加信用卡。点击「+ 新增」添加第一张。',
  'settings.editCard': '编辑信用卡',
  'settings.deleteCard': '删除信用卡',
  'settings.newCard': '新增信用卡',
  'settings.recurringTitle': '固定每月收入/支出 ({count})',
  'settings.editRecurring': '编辑固定规则',
  'settings.deleteRecurring': '删除固定规则',
  'settings.newRecurring': '新增固定规则',
  'settings.expenseCatsTitle': '支出类别 ({count})',
  'settings.incomeCatsTitle': '收入类别 ({count})',
  'settings.newCategory': '新增类别',
  'settings.editCategory': '编辑类别',
  'settings.deleteCategoryConfirm': '删除类别「{name}」?',
  'settings.deleteRecurringConfirm': '删除这条固定规则?',
  'settings.deleteCardConfirm': '删除这张信用卡?',
  'signin.loadGoogleFailed': '无法加载 Google 登录: {msg}',
  'signin.tagline': '用 Google 账号登录,所有数据只属于你',
  'signin.googleNotConfigured': 'Google 登录未配置 (缺少 GOOGLE_CLIENT_ID)',
  'signin.signingIn': '登录中...',
  'cmd.newTx': '新增交易',
  'cmd.goTo': '前往',
  'appearance.theme': '主题',
  'appearance.light': '浅色',
  'appearance.dark': '深色',
  // Phase 81: replaced misleading "默认跟随系统" hint.
  'appearance.themeHint': '选择后即时生效',
  'appearance.notifications': '浏览器通知',
  'appearance.notifDenied': '通知权限被拒,请到浏览器设置开启。',
  'appearance.notifLabel': '信用卡 grace period critical 时弹出通知',
  // Phase 81: removed dev-environment copy.
  'appearance.notifHint': '需要允许浏览器通知权限。',
  'recap.title': '本周回顾',
  'recap.expenseFmt': '本周共花了 {amount}',
  'recap.topCategoryFmt': '最多:{category} {amount}',
  'recap.upVsLastWeek': '比上周多',
  'recap.downVsLastWeek': '比上周少',
  'appearance.weeklyRecap': '每周回顾通知',
  'appearance.weeklyRecapHint': '每周日提醒你本周开支。',
  'appearance.compactFilter': '简化筛选列',
  'appearance.compactFilterHint': '隐藏类别筛选以节省顶部空间',
  // Phase 81: distinct section heading (was duplicating the toggle label).
  'appearance.compactFilterTitle': '交易页筛选',
  'installments.title': '信用卡分期',
  'installments.add': '新增分期',
  'installments.empty': '尚无分期记录',
  'installments.total': '总金额',
  'installments.monthlyAmount': '每月还款',
  'installments.periods': '已还 {paid}/{total} 期',
  'installments.remaining': '还剩 {n} 期',
  'installments.nextPayment': '下次还款',
  'installments.complete': '已还完',
  'installments.markPaid': '标记本期已还',
  'installments.markEnded': '标记分期完成',
  'installments.note': '备注 (购买项目)',
  'installments.totalAmount': '总金额',
  'installments.totalPeriods': '期数',
  'installments.startMonth': '开始月份',
  'installments.card': '信用卡',
  'installments.future.title': '未来分期',
  'installments.future.subtitle': '共 {n} 期未还,合计 {total}',
  'installments.notify.title': '信用卡分期还款',
  'installments.notify.body': '{card} · {amount} · 第 {period}/{total} 期{note_sfx}',
  'installments.notify.noteSuffix': ' ({note})',
  'currency.title': '货币显示',
  'currency.saveFailed': '设置失败: {msg}',
  'currency.addFailed': '添加失败: {msg}',
  'currency.keepOne': '至少保留一个 symbol',
  'currency.deleteSym': '删除 {sym}',
  'currency.addAria': '添加新货币符号',
  'currency.preview': '当前显示: {amount}',
  'data.title': '数据管理',
  'data.importHint': '从 CSV 文件导入交易记录',
  'data.importAria': '选择 CSV 文件',
  'data.importColumns': '字段顺序: type, amount, category, occurred_on, note, tags',
  'data.importing': '导入中…',
  'data.importOk': '成功 {imported} 条,跳过 {skipped} 条',
  'data.importOkErrors': ' · {n} 个错误',
  'data.importFailed': '导入失败: {msg}',
  'data.exportHint': '下载所有交易为 CSV 文件',
  'data.exportBtn': '导出 CSV',
  'data.exporting': '导出中…',
  'data.exportOk': '已导出 {n} 条交易',
  'data.exportFailed': '导出失败: {msg}',
  'data.clearHint': '删除所有交易记录(类别、预算、设置会保留)',
  'data.clearAll': '删除所有交易',
  'data.clearConfirm': '确认删除所有交易?此操作无法复原。',
  'data.clearing': '删除中…',
  'data.confirmClear': '确认删除',
  'data.clearedN': '已删除 {n} 条交易',
  'data.clearFailed': '删除失败: {msg}',
  // Phase 47: redesigned DataSection visual hierarchy
  'data.dangerZone': '危险区域',
  'data.dangerZoneDesc': '这些操作无法复原,请谨慎使用。',
  'data.importDrop': '点击或拖放 CSV 文件到此处',
  'data.importDropHint': '支持 .csv 格式',
  'account.title': '账户绑定',
  'account.subtitle': '同步至其他设备。',
  'account.noName': '(无名)',
  'account.signOutConfirm': '确定登出?',
  'account.signOut': '登出',
  'account.saveFailed': '保存失败:{msg}',
  // Phase 46: local-vs-cloud 账号 UI
  'account.localBadge': '本地账户',
  'account.localDesc': '仅存于此设备。无备份、无同步。',
  'account.deleteLocal': '删除本地账户',
  'account.deleteLocalConfirm': '删除此本地账户?此设备上所有资料将永久删除。',
  'account.deleteLocalDone': '本地账户已删除',
  'account.connectGoogle': '绑定 Google 账户',
  'account.connectGoogleDesc': '同步交易至其他设备。',
  'account.googleComingSoon': '即将推出 — Phase B',
  'account.deleteLocalHint': '此操作无法复原。',
  // Phase 46b: bullet-style local-account description + new keys
  'account.connected': '已连接',
  'account.localBullet.device': '保存于此设备',
  'account.localBullet.noBackup': '无备份',
  'account.localBullet.noSync': '无同步',
  // Phase 40: developer card (local-only sample data)
  'developer.title': '开发者选项',
  'developer.version': 'App 版本',
  'developer.localOnly': '仅写入此设备的 IndexedDB,绝不会到达服务器。',
  'developer.seed500': '产生 500 笔示例交易',
  'developer.seed100': '产生 100 笔示例交易',
  'developer.seed10y': '产生 1200 笔 / 10 年示例',
  'developer.seedConfirm': '向此设备插入 {n} 笔随机示例交易（分布于 {y} 年内）?',
  'developer.seedOk': '已插入 {n} 条示例交易。',
  'developer.resetTx': '删除此设备所有交易',
  'developer.resetConfirm': '删除此设备的全部交易?此操作无法撤销。',
  'developer.resetOk': '已删除 {n} 条交易。',
  'developer.working': '处理中…',
  'developer.failed': '失败: {msg}',
  'topbar.search': '全局搜索',
  'topbar.searchTitle': '全局搜索 (Cmd/Ctrl+K)',
  'topbar.themeLight': '切换浅色',
  'topbar.themeDark': '切换深色',
  'topbar.quickAdd': '新增交易',
  'topbar.filters': '切换筛选',
  'topbar.searchTip': '按 / 或 Cmd+K 都可以',
  'fab.newTx': '新增交易',
  'common.refresh.release': '↓ 松开更新',
  'common.refresh.refreshing': '⟳ 更新中…',
  'budgets.notSet': '未设置预算',
  'budgets.notSetHint': '去「预算」页面设置每月上限',
  'budgets.budgetsCount': '个预算',
  'budgets.overCount': '个超支',
  'budgets.warnCount': '个接近',
  'budgets.over': '超支',
  'budgets.warn': '接近',
  'budgets.progressAria': '{name} 已用 {pct}',
  'tx.seeAllFmt': '查看全部 ({count})',
  'tx.emptyCta': '新增交易',
  'tx.listCountFmt': '显示 {shown} / {total} 笔',
  'category.noExpense': '暂无支出记录',
  'settings.categoryNameRequired': '请输入名称',
  'settings.reorderFailed': '重新排序失败: {msg}',
  'settings.moveUp': '向上移',
  'settings.moveDown': '向下移',
  'settings.reorder': '拖曳以重新排序',
  'settings.cardSettleConfirm': '确认已还款?本期累计会重设为 0。',
  'settings.cardSettleTitle': '确认已还款,重设本期累计',
  'settings.cardSettleFailed': '还款确认失败: {msg}',
  'settings.cardStatementDue': '账单日 {stmt} · 到期日 {due}',

  'settings.cardDueToday': '今日到期',
  'settings.cardDueTomorrow': '明日到期',
  'settings.cardDueInDays': '{n} 日后到期',
  'settings.cardGraceRemaining': '剩 {n} 日免息期',
  'settings.cardOverdue': '已逾期 {n} 日',
  'settings.cardOutstanding': '本期累计 {amount}',
  'settings.cardSettle': '确认还款',

  'settings.cardPaid': '已还款',
  'settings.statementDay': '账单日',
  'settings.expiryMonth': '到期月份 (MM)',
  'settings.expiryYear': '到期年 (YY)',
  'settings.expiryMonthPlaceholder': '例: 8',
  'settings.expiryYearPlaceholder': '例: 27',
  'settings.expiryHint': '可留空。月份和年份要一起填。',
  'settings.recurringHint': '设定后,每次打开 Dashboard 会自动记录当月交易(使用本地时间)。',
  'settings.category.editorHint': '输入名称、选择类型，再选择图标和颜色。',
  'signin.appTitle': '记账 App',
  'common.add': '新增',
  'common.all': '全部',
  'categories.餐飲': '餐饮',
  'categories.交通': '交通',
  'categories.水費': '水费',
  'categories.電費': '电费',
  'categories.煤氣': '煤气',
  'categories.居家': '居家',
  'categories.投資': '投资',
  'categories.娛樂': '娱乐',
  'categories.購物': '购物',
  'categories.醫療': '医疗',
  'categories.稅務': '税务',
  // Phase 82b: renamed from 交卡數 to 卡數.
  'categories.卡數': '还卡款',
  'categories.其他': '其他',
  'categories.薪金': '工资',
  'categories.投資回報': '投资回报',
  'categories.獎金': '奖金',
  'cmd.ariaLabel': '指令面板',
  'cmd.searchPlaceholder': '搜索交易、类别、预算、固定、信用卡...',
  'cmd.loading': '载入中…',
  'cmd.noResults': '没有符合「{q}」的结果',
  'cmd.footerHint': '↑↓ 选择 · ↵ 确认 · ESC 关闭',
  'cmd.toOpen': '打开',
  'cmd.expenseCat': '支出类别',
  'cmd.incomeCat': '收入类别',
  'cmd.budget': '预算',
  'cmd.perMonth': '每月',
  'cmd.dayOfMonth': '日',
  'cmd.outstanding': '未还',
    'cardDetail.title': '信用卡交易',
    'cardDetail.empty': '这张卡暂时没有交易记录',
    'cardDetail.notFound': '找不到此卡',
    'cardDetail.outstanding': '尚欠金额',
    'cardDetail.nextDue': '到期日',
    'cardDetail.cycle': '账单周期',
    'cardDetail.markPaid': '标记今日已缴',
    'cardDetail.transactions': '交易记录',
    'cardDetail.addTagged': '新增交易',
    'cardDetail.openCard': '查看{name}的交易',
    'cardDetail.paidOn':   '已于 {date} 缴付',

    // Phase 102: First-time onboarding carousel.
    'onboard.step1.title':      '设置你的语言和货币',
    'onboard.step1.body':       '选择你常用的语言和货币符号。之后可以在设置里更改。',
    'onboard.step1.langLabel':  '语言',
    'onboard.step1.curLabel':   '货币符号',
    'onboard.step1.preview':    '当前显示',
    'onboard.step2.title':      '记下你的第一笔',
    'onboard.step2.body':       '几秒钟就可以记一笔,之后可以随时添加、修改、删除。',
    'onboard.step2.bullet1':    '选择收支类型(支出/收入)',
    'onboard.step2.bullet2':    '输入金额并选类别',
    'onboard.step2.bullet3':    '保存后立即在主页看到',
    'onboard.step2.tipNote':    '提示:首次记帐时会看到 3 个小贴士,可以逐个点「知道了」收起。',
    'onboard.step3.title':      '本地优先 + 云端备份',
    'onboard.step3.body':       '你的资料存储在设备上,离线也能用。Google 登录后可跨设备同步。',
    'onboard.step3.bullet1':    '本地存储:快、离线可用',
    'onboard.step3.bullet2':    'Google 登录(可选):跨设备同步',
    'onboard.step3.signinNote': '登录后会自动推送本地资料到云端,无需手动操作。',
    'onboard.back':             '返回',
    'onboard.next':             '下一步',
    'onboard.skip':             '跳过',
    'onboard.later':            '稍后再说',
    'onboard.logNow':           '立即记一笔',
    'onboard.start':            '开始使用',
    'onboard.tooltip.type':     '👆 开支和收入分开记,统计更清楚。',
    'onboard.tooltip.amount':   '💰 金额可以用快速键盘输入。',
    'onboard.tooltip.category': '🏷️ 选类别方便之后看趋势。',
    'onboard.tooltip.gotIt':    '知道了',
    'onboard.replay.title':     '教程',
    'onboard.replay.body':      '重新走一次新手教程。',
    'onboard.replay.button':    '重新播放教程',

    // Phase 104: collapsible group titles + privacy mode.
    'settings.group.prefs':    '偏好 / Preferences',
    'settings.group.tracking': '记账 / Tracking',
    'settings.group.data':     '资料 / Data',
    'settings.group.help':     '说明 / Help',
    'privacy.title':           '隐藏金额',
    'privacy.body':            '开启后,Dashboard/交易/预算金额会隐藏,点一下显示 5 秒。',

    // Phase 103: Reset All Settings (destructive).
    'resetAll.title':         '初始化所有设置',
    'resetAll.body':          '清除所有本地资料:交易、账户、类别、预算、固定收支、信用卡、储蓄目标、安装分期、设置。服务器上的资料会保留。清除后会重新弹出新手教程。',
    'resetAll.button':        '初始化所有设置',
    'resetAll.confirmTitle':  '确认要清除所有本地资料?',
    'resetAll.confirmBody':   '此操作无法复原。请输入 {phrase} 以确认。',
    'resetAll.confirmLabel':  '输入 DELETE',
    'resetAll.confirmButton': '永久清除',
    'resetAll.failed':        '初始化失败:{msg}',

    // Phase 202d/202e: Sync section + destructive server wipe.
    'settings.sync.title':                  '跨设备同步',
    'settings.sync.desc':                   '从 Google 账号重新拉取所有资料到本机。新设备或重装后使用。',
    'settings.sync.button':                 '重新同步',
    'settings.sync.wipeButton':             '清空本机并重新同步',
    'settings.sync.wipeConfirmTitle':       '此操作会清除本机所有交易、类别、信用卡、定期、预算、目标、账户,然后重新从服务器拉取。',
    'settings.sync.wipeConfirmWarn':        '尚未成功上传到服务器的本机资料会永久遗失。建议先按上方「重新同步」确认服务器有资料,再执行此操作。',
    'settings.sync.wipeExecute':            '确认清空并重新同步',
    'settings.sync.wipeServerButton':       '清空服务器资料并重新登录',
    'settings.sync.wipeServerConfirmTitle': '此操作会删除服务器上您账号的所有交易、类别、信用卡、定期、预算、目标、设置,以及您的账号记录。',
    'settings.sync.wipeServerConfirmWarn':  '服务器资料删除后无法复原。完成后页面会自动重新加载,您需要重新以 Google 账号登录。',
    'settings.sync.wipeServerExecute':      '确认清空服务器',
    'common.error':                         '发生错误',

  // Phase 208 / card 208-D1 — recurring-transaction reminders.
  'recurring.reminder.title': '提醒',
  'recurring.reminder.countFmt': '{count} 笔即将发生的固定交易',
  'recurring.reminder.itemFmt': '{category} · {amount} · {when}',
  'recurring.reminder.dueToday': '今天到期',
  'recurring.reminder.dueInDays': '{n} 天后到期',
  'recurring.reminder.appliedFmt': '{name} 已自动添加',
  'recurring.reminder.toggleLabel': '在记账前提醒我',
  'recurring.reminder.leadLabel': '提前 {n} 天提醒我',
  'recurring.reminder.globalToggle': '固定交易提醒',
  'recurring.reminder.globalHint': '下次打开 app 时会提示你,在固定收入／支出入账前。',
};
